import React from 'react'
import { Stack, Typography } from '@mui/material'
import { ChargingPoint } from '@/types/ChargingPoint'
import { tariffUtils } from '@/utils/tariff'
import { numericUtils } from '@/utils/numeric'

export const IdleTariffSchedule: React.FC<{ chargingPoint: ChargingPoint }> = ({ chargingPoint }) => (
  <Stack spacing={0.5}>
    <Typography variant="body2" color="text.secondary">
      Horários de hoje · Fuso: {chargingPoint.tariff_plan?.timezone ?? 'não informado'}
    </Typography>
    {chargingPoint.idle_timeline?.map((segment) => (
      <Typography key={`${segment.start}-${segment.end}`} variant="body2" color="text.secondary">
        {tariffUtils.formatTimeRange(segment.start, segment.end)} ·{' '}
        <Typography component="span" variant="body2" fontWeight="bold" color="primary">
          {Number(segment.rate) > 0
            ? `${numericUtils.formatNumberToBRLCurrency(Number(segment.rate))}/min`
            : 'sem cobrança'}
        </Typography>
      </Typography>
    ))}
  </Stack>
)
